import JSBI from 'jsbi';
import { ZERO } from '../constants/internalConstants';

interface FeeGrowthOutside {
  feeGrowthOutside0X128: JSBI;
  feeGrowthOutside1X128: JSBI;
}

const Q256 = JSBI.exponentiate(JSBI.BigInt(2), JSBI.BigInt(256));

export function subIn256(x: JSBI, y: JSBI): JSBI {
  const difference = JSBI.subtract(x, y);

  if (JSBI.lessThan(difference, ZERO)) {
    return JSBI.add(Q256, difference);
  }
  return difference;
}

export abstract class TickLibrary {
  /**
   * Cannot be constructed.
   */
  private constructor() {}

  public static getFeeGrowthInside(
    feeGrowthOutsideLower: FeeGrowthOutside,
    feeGrowthOutsideUpper: FeeGrowthOutside,
    tickLower: number,
    tickUpper: number,
    tickCurrent: number,
    feeGrowthGlobal0X128: JSBI,
    feeGrowthGlobal1X128: JSBI
  ) {
    let feeGrowthBelow0X128: JSBI;
    let feeGrowthBelow1X128: JSBI;
    if (tickCurrent >= tickLower) {
      feeGrowthBelow0X128 = feeGrowthOutsideLower.feeGrowthOutside0X128;
      feeGrowthBelow1X128 = feeGrowthOutsideLower.feeGrowthOutside1X128;
    } else {
      feeGrowthBelow0X128 = subIn256(
        feeGrowthGlobal0X128,
        feeGrowthOutsideLower.feeGrowthOutside0X128
      );
      feeGrowthBelow1X128 = subIn256(
        feeGrowthGlobal1X128,
        feeGrowthOutsideLower.feeGrowthOutside1X128
      );
    }

    let feeGrowthAbove0X128: JSBI;
    let feeGrowthAbove1X128: JSBI;
    if (tickCurrent < tickUpper) {
      feeGrowthAbove0X128 = feeGrowthOutsideUpper.feeGrowthOutside0X128;
      feeGrowthAbove1X128 = feeGrowthOutsideUpper.feeGrowthOutside1X128;
    } else {
      feeGrowthAbove0X128 = subIn256(
        feeGrowthGlobal0X128,
        feeGrowthOutsideUpper.feeGrowthOutside0X128
      );
      feeGrowthAbove1X128 = subIn256(
        feeGrowthGlobal1X128,
        feeGrowthOutsideUpper.feeGrowthOutside1X128
      );
    }

    return [
      subIn256(
        subIn256(feeGrowthGlobal0X128, feeGrowthBelow0X128),
        feeGrowthAbove0X128
      ),
      subIn256(
        subIn256(feeGrowthGlobal1X128, feeGrowthBelow1X128),
        feeGrowthAbove1X128
      ),
    ];
  }
}
